<template lang="pug">
  div.add-to-compare
    .form-check.form-check-inline(@click="toggle")
      input.form-check-input.add-to-compare__checkbox(type="checkbox" readonly="readonly" :checked="isAdded()")
      label.form-check-label.add-to-compare__label
        font-awesome-icon(:icon=['far', 'check'])
        | {{ trans('labels.frontend.compare.compare') }}
</template>

<script>
  import notify from "../../notify";

  export default {
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isLoading: false,
      };
    },
    methods: {
      isAdded() {
        return _.findIndex(this.$store.getters['compare/items'], { 'item_code': this.item.item_code }) >= 0;
      },
      async toggle() {
        try {
          if (!this.isAdded()) {
            const categories = _.map(this.$store.getters['compare/items'], 'main_category');
            let comparison;
            if (typeof this.item.main_category === 'object') {
              comparison = this.item.main_category.name.toLowerCase();
            } else {
              comparison = this.item.main_category.toLowerCase();
            }
            if (
              ((categories.indexOf(comparison) > -1) && categories.length > 0) || categories.length === 0
            ) {
              if (this.$store.getters['compare/items'].length >= 5) {
                notify.message(this, { title: Lang.get('alerts.frontend.compare.max_products'), text: false }, 'danger');
                return;
              }
              await this.$store.dispatch('compare/add', this.item);
            } else {
              notify.message(this, { title: Lang.get('alerts.frontend.compare.different_category'), text: false }, 'danger');
            }
          } else {
            await this.$store.dispatch('compare/remove', this.item);
          }
        } catch (e) {
          console.log(e);
          notify.errors(this, e);
        }
      },
    }
  }
</script>
